/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Auth from "@/services/Auth.js"

Vue.use(Router)

// Create a new router
const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: () => import('@/views/Admin/AdminHome')
        },
        {
            path: '/dashboard',
            name: 'Organisations',
            component: () => import('@/views/Admin/AdminHome')
        },
        {
            path: '/dashboard-ui',
            name: 'Organisations',
            component: () => import('@/views/Dashboard')
        },
        {
            path: '/user-profile',
            name: 'Account',
            component: () => import('@/views/Account/Account')
        },
        {
            path: '/firmware',
            name: 'Firmware Management',
            component: () => import('@/views/Firmware/FirmwareManagement')
        },
        {
            path: '/faults',
            name: 'Faults',
            component: () => import('@/views/Faults/Faults')
        },
        {
            path: '/typography',
            name: 'Typography',
            component: () => import('@/views/Typography')
        },
        {
            path: '/fleetstatus',
            name: 'Fleet Status',
            component: () => import('@/views/FleetStatus/FleetStatus.vue')
        },
        {
            path: '/icons',
            name: 'Icons',
            component: () => import('@/views/Icons')
        },
        {
            path: '/maps',
            name: 'Maps',
            component: () => import('@/views/Maps')
        },
        {
            path: '/notifications',
            name: 'Notifications',
            component: () => import('@/views/Notifications')
        },
        {
            path: '/upgrade',
            name: 'Upgrade to PRO',
            component: () => import('@/views/Upgrade')
        },
        {
            path: '/jobs',
            name: 'Jobs',
            component: () => import('@/views/Jobs/Jobs')
        },
        {
            path: '/log-files',
            name: 'Log Files',
            component: () => import('@/views/LogFiles/LogFiles')
        },
        {
            path: '/device-management',
            name: 'Device Management',
            component: () => import('@/views/DeviceManagement/DeviceManagement')
        },
        {
            path: '/organisation/:name',
            name: 'Organisation',
            component: () => import('@/views/OrgProfile/OrgProfileBase'),
            children: [
                {
                    path: '/',
                    name: 'Profile',
                    component: () => import('@/views/OrgProfile/OrgProfile')
                },
                {
                    path: 'users',
                    name: 'Users',
                    component: () => import('@/views/OrgUsers/OrgUsers')
                },
                {
                    path: 'vehicles',
                    name: 'Vehicles',
                    component: () => import('@/views/OrgVehicles/OrgVehicles')
                },
                {
                    path: 'manage',
                    name: 'Manage',
                    component: () => import('@/views/OrgManage/OrgManage')
                },
            ]
        },
        {
            path: '/vehicles',
            name: 'Vehicles',
            component: () => import('@/views/Vehicles/Vehicles')
        },
        {
            path: '/device-information',
            name: 'Device Information',
            component: () => import('@/views/DeviceInformation/DeviceInformation')
        },
        {
            path: '/search-results',
            name: 'Search Results',
            component: () => import('@/views/SearchResults/SearchResults')
        },
        {
            path: '/user-activity',
            name: 'User Activity',
            component: () => import('@/views/UserActivity/UserActivity')
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return { selector: to.hash }
        }
        return { x: 0, y: 0 }
    }
});

router.beforeEach(async (to, from, next) => {
    const user = await Auth.currentSession();
    const role = user.User['custom:role'];
				
    if (role.toLowerCase() == 'sys_admin' || role.toLowerCase() == 'support_admin' || role.toLowerCase() == 'support_lead' || role.toLowerCase() == 'firmware_manager') {
        next();
    } else {
       location.replace(location.protocol + "//" + process.env.VUE_APP_user_domain);
    }
    
});

Vue.use(Meta)

export default router
